import { Show } from "solid-js";
import type { SignalModule } from "../../enums/scan";
import { SIGNAL_MODULE } from "../../enums/scan";
import type { WebsiteContext } from "../website/store";
import { createDismissable } from "./createDismissable";
import { ScanScheduler } from "./ScanScheduler";
import { SIGNAL_DESTINATIONS, signalDestinationHref } from "./signalModules";

export function ScanWorkspaceMenus(props: {
  context: WebsiteContext;
  activeModule: SignalModule | "none";
}) {
  const website = createDismissable();
  const utilities = createDismissable();
  const data = () => props.context.data();
  const siteName = () =>
    data()?.site.displayName ?? data()?.site.clientName ?? "Loading site";
  const href = (module: SignalModule) =>
    signalDestinationHref(props.context.websiteId, module);
  return (
    <div class="signal-top-actions">
      <div class="signal-website-selector">
        <button
          ref={website.setTrigger}
          class="signal-site-selector"
          type="button"
          aria-expanded={website.open()}
          aria-controls="signal-website-selector-menu"
          title={siteName()}
          onClick={() => {
            utilities.setOpen(false);
            website.toggle();
          }}
        >
          <i class="signal-site-status-dot" aria-hidden="true" />
          <span class="signal-site-selector-name">{siteName()}</span>
          <span aria-hidden="true">⌄</span>
        </button>
        <Show when={website.open()}>
          <nav
            id="signal-website-selector-menu"
            class="signal-top-menu signal-website-selector-menu"
            aria-label="Website workspace"
          >
            <strong>{siteName()}</strong>
            <span>{data()?.site.domain}</span>
            <a
              href={href(SIGNAL_MODULE.OVERVIEW)}
              aria-current={
                props.activeModule === SIGNAL_MODULE.OVERVIEW
                  ? "page"
                  : undefined
              }
              onClick={() => website.setOpen(false)}
            >
              {SIGNAL_DESTINATIONS[SIGNAL_MODULE.OVERVIEW].label}
            </a>
            <a href="/" onClick={() => website.setOpen(false)}>
              All websites
            </a>
          </nav>
        </Show>
      </div>
      <div class="signal-utility-menu">
        <button
          ref={utilities.setTrigger}
          class="signal-top-menu-trigger"
          classList={{
            "is-active": props.activeModule === SIGNAL_MODULE.SETTINGS,
          }}
          type="button"
          aria-expanded={utilities.open()}
          aria-controls="signal-utility-menu"
          onClick={() => {
            website.setOpen(false);
            utilities.toggle();
          }}
        >
          Utilities
        </button>
        <Show when={utilities.open()}>
          <section
            id="signal-utility-menu"
            class="signal-top-menu"
            aria-label="Website utilities"
          >
            <a
              href={href(SIGNAL_MODULE.SETTINGS)}
              aria-current={
                props.activeModule === SIGNAL_MODULE.SETTINGS
                  ? "page"
                  : undefined
              }
              onClick={() => utilities.setOpen(false)}
            >
              {SIGNAL_DESTINATIONS[SIGNAL_MODULE.SETTINGS].label}
            </a>
            <ScanScheduler context={props.context} />
            <a
              href={`/w/${props.context.websiteId}/help`}
              onClick={() => utilities.setOpen(false)}
            >
              Help
            </a>
          </section>
        </Show>
      </div>
    </div>
  );
}
